// extracted by mini-css-extract-plugin
module.exports = {"root":"_2PgFN","title":"_3QQWM","separator":"oJx74","description":"_2VhrA","button":"_1PDhp"};